import { render, staticRenderFns } from "./projectStatusChip.vue?vue&type=template&id=0ba76f27&v-slot%3Aitem.status=%7B%20item%20%7D&"
import script from "./projectStatusChip.vue?vue&type=script&lang=js&"
export * from "./projectStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
